'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import { ReactNode } from 'react'

import { TooltipContent } from './_tooltip-content'

type TooltipFeedbackProps = {
  help: string
  children: ReactNode
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Internal controlled tooltip for transient feedback (e.g. CopyButton copy result).
 * Not exported — hover/focus help uses {@link Tooltip} instead.
 */
export function TooltipFeedback({
  help,
  children,
  open,
  onOpenChange,
}: TooltipFeedbackProps) {
  return (
    <TooltipPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipContent help={help} />
    </TooltipPrimitive.Root>
  )
}
